import { style, styleVariants } from '@vanilla-extract/css';
import { vars } from '../../theme/contract.css';
import { reducedMotion } from '../../theme/media';

export const content = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
});

/** 결과 한 문장 — 착수 때 쓴 제목을 끝내는 자리에서 결과로 고친다. */
export const titleField = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
});

export const titleHint = style({
  margin: 0,
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.tertiary,
});

/** 체크인→체크아웃 2스텝 개념 정적 안내 (dismiss 없음). */
export const helpText = style({
  margin: 0,
  fontSize: vars.typography.fontSize.sm,
  color: vars.typography.textColor.secondary,
});

export const planRow = style({
  display: 'flex',
  alignItems: 'baseline',
  gap: '8px',
  margin: 0,
  padding: '8px 12px',
  background: vars.surface.card.default,
  borderRadius: '8px',
  border: `1px solid ${vars.surface.border.secondary}`,
});

export const planLabel = style({
  margin: 0,
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.tertiary,
});

export const planValue = style({
  margin: 0,
  fontSize: vars.typography.fontSize.md,
  fontWeight: vars.typography.fontWeight.semibold,
  color: vars.typography.textColor.primary,
});

export const label = style({
  fontSize: vars.typography.fontSize.sm,
  fontWeight: vars.typography.fontWeight.medium,
  color: vars.typography.textColor.secondary,
});

export const required = style({
  color: vars.bright.status.error,
});

export const input = style({
  width: '100%',
  padding: '10px 12px',
  fontSize: vars.typography.fontSize.sm,
  fontFamily: vars.typography.fontFamily.primary,
  color: vars.typography.textColor.primary,
  background: vars.surface.card.default,
  border: `1px solid ${vars.surface.border.secondary}`,
  borderRadius: '8px',
  outline: 'none',
  transition: `border-color ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}`,
  ':focus-visible': {
    borderColor: vars.surface.border.primary,
  },
  '@media': {
    [reducedMotion]: {
      transition: 'none',
    },
  },
});

const diffBase = {
  margin: 0,
  fontSize: vars.typography.fontSize.xs,
  fontWeight: vars.typography.fontWeight.medium,
};

/** 계획 대비 실제 차이 방향 색상 (초과=success / 미달=warning). */
export const diffHint = styleVariants({
  over: { ...diffBase, color: vars.bright.status.success },
  under: { ...diffBase, color: vars.bright.status.warning },
});

export const textarea = style({
  width: '100%',
  minHeight: '72px',
  padding: '12px',
  fontSize: vars.typography.fontSize.sm,
  fontFamily: vars.typography.fontFamily.primary,
  color: vars.typography.textColor.primary,
  background: vars.surface.card.default,
  border: `1px solid ${vars.surface.border.secondary}`,
  borderRadius: '8px',
  resize: 'vertical',
  outline: 'none',
  transition: `border-color ${vars.animation.duration.fast} ${vars.animation.easing.easeOut}`,
  ':focus-visible': {
    borderColor: vars.surface.border.primary,
  },
  '::placeholder': {
    color: vars.typography.textColor.tertiary,
  },
  '@media': {
    [reducedMotion]: {
      transition: 'none',
    },
  },
});

export const charCount = style({
  fontSize: vars.typography.fontSize.xs,
  color: vars.typography.textColor.tertiary,
  textAlign: 'right',
});

/** 계획≠실제일 때 나타나는 차이 힌트+사유 묶음 (aria-live 라이브 리전). */
export const varianceFields = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '12px',
});

/** "지금까지 적립 46명" — 숫자 뒤 단위. 표시 전용. */
export const unitSuffix = style({
  marginLeft: '2px',
  fontSize: vars.typography.fontSize.xs,
  fontWeight: vars.typography.fontWeight.regular,
  color: vars.typography.textColor.tertiary,
});

/** 두 칸 연동 — "오늘 한 건수" ⇄ "누적 완료 건수". 한쪽을 치면 다른 쪽이 계산돼 뜬다. */
export const twoFields = style({
  display: 'grid',
  gridTemplateColumns: 'minmax(0, 1fr) auto minmax(0, 1fr)',
  gap: '8px',
  alignItems: 'end',
});

export const field = style({
  display: 'flex',
  flexDirection: 'column',
  gap: '6px',
  minWidth: 0,
});

export const arrow = style({
  alignSelf: 'center',
  paddingBottom: '10px',
  color: vars.typography.textColor.tertiary,
  fontSize: vars.typography.fontSize.md,
});

/** 계산돼 뜬 칸 — 사람이 적은 칸과 구별되게 흐리게. 덮어쓰면 일반 입력으로 돌아온다. */
export const calcInput = style({
  color: vars.typography.textColor.tertiary,
});

export const calcTag = style({
  marginLeft: 'auto',
  fontSize: vars.typography.fontSize['2xs'],
  fontWeight: vars.typography.fontWeight.regular,
  color: vars.typography.textColor.softMuted,
  border: `1px solid ${vars.surface.border.secondary}`,
  borderRadius: '3px',
  padding: '0 5px',
});

/** 검산 실패·적립 미달 안내 — 막지 않고 묻는 문장. */
export const checkHint = style({
  ...diffBase,
  color: vars.bright.status.warning,
});
